








import { Component, Mixins, Model, Prop, Emit } from "vue-property-decorator";
import { DisableableMixin } from "./mixins";

@Component
export default class NumberInput extends Mixins(DisableableMixin) {
  @Model("input")
  value: number;

  @Emit()
  input(value: number): void {}

  @Prop({ default: "text-align: right; width: 4em;" })
  inputStyle: string;

  @Prop({ default: null })
  buttonStyle: string;

  @Prop({ type: Function, default: (v: number) => v })
  correct: (v: number) => number;

  @Prop({ type: Function, default: (v: number) => true })
  validate: (v: number) => boolean;

  @Prop({ default: false })
  enableStep: boolean;

  @Prop({ default: 1 })
  step: number;

  get editingSource(): number {
    const value = this.value; // 直接correct()に渡すとProp更新となる場合がありワーニングが出るため
    const correctedValue = this.correct(value);
    if (isNaN(correctedValue) || !this.validate(correctedValue) || correctedValue !== value) {  // nullは許容する
      console.warn("Initial value outside the specified range.", value);
    }
    return correctedValue;
  }

  set editingSource(value: number) {
    const correctedValue = this.correct(value);
    if (isNaN(correctedValue) || !this.validate(correctedValue) || typeof value !== "number") {
      // input()で通知しないことで元の値に戻す
      return;
    }
    this.input(correctedValue);
  }

  get disabledSubtract(): boolean {
    const correctedValue = this.correct(this.editingSource - this.step);
    return this.disabled || isNaN(correctedValue) || !this.validate(correctedValue);
  }

  get disabledAdd(): boolean {
    const correctedValue = this.correct(this.editingSource + this.step);
    return this.disabled || isNaN(correctedValue) || !this.validate(correctedValue);
  }

  subtract() {
    this.editingSource -= this.step;
  }

  add() {
    this.editingSource += this.step;
  }
}
